/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * cost type for services like TSP-s and OCSP responders
 */
export enum CostType {
    FREE = 'FREE',
    PAID = 'PAID',
    UNDEFINED = 'UNDEFINED',
}
